import request from '@teetsh/app/src/utils/request';

interface DuplicateEntityParams {
  token: string;
  entityId: string;
  entityType: string;
  destSchoolId: string;
  classroomsMapping?: Array<{ from: string; to?: string }>;
}

export function duplicateEntity({
  token,
  entityId,
  entityType,
  destSchoolId,
  ...rest
}: DuplicateEntityParams) {
  return request(`/shares/${token}/duplicate`, {
    method: 'POST',
    body: {
      id: entityId,
      entityType,
      destSchoolId,
      ...rest,
    },
  });
}
